// extracted by mini-css-extract-plugin
module.exports = {"main":"main_main__15GF2","header":"main_header__26UIy","content":"main_content__1dGl4","mobile":"main_mobile__1FdOY"};